import React, { useMemo } from "react";
import { Modal, Button } from "react-bootstrap";
import { QUESTION_KIND, resolveQuestionKind } from "../runtime/questionKinds";
import { useModuleRuntime } from "../runtime/useModuleRuntime";
import OnlyTextQuestion from "../runtime/questions/OnlyTextQuestion";
import TestQuestion from "../runtime/questions/TestQuestion";
import DropdownQuestion from "../runtime/questions/DropdownQuestion";
import GameQuestion from "../runtime/questions/GameQuestion";

import "./Module.css";
import "./responsive.css";

function Module({ module }) {
  const title = module?.title || "";
  const questions = useMemo(
    () => (Array.isArray(module?.questions) ? module.questions : []),
    [module]
  );

  const {
    currentQuestion,
    selectedQuestionIndex,
    isLastQuestion,
    outOfAttempts,
    score,
    showModal,
    state,
    selectOption,
    closeFeedback,
    setDropdownSelection,
    setGameOver,
    handleScoreUpdate,
    checkAnswer,
    nextQuestion,
    finishQuiz,
    closeModal,
  } = useModuleRuntime(questions);

  if (!currentQuestion) {
    return (
      <div className="test-container">
        <div className="test-title" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="placeholder-content">
          <p>Для даного модуля завдання не призначено</p>
        </div>
      </div>
    );
  }

  const kind = resolveQuestionKind(currentQuestion);
  const containerClassName = `test-container${kind === QUESTION_KIND.DND ? " game" : ""}`;

  const showNextForTest = (outOfAttempts || state.showNextButton) && !isLastQuestion;
  const showFinishForTest =
    isLastQuestion && (state.showNextButton || Boolean(currentQuestion.isCreativeTask));

  const showNextForDropdown = (outOfAttempts || state.showNextButton) && !isLastQuestion;
  const showFinishForDropdown = isLastQuestion;

  const showNextForGame = !isLastQuestion;
  const showFinishForGame = isLastQuestion;

  return (
    <div className={containerClassName}>
      {showModal && (
        <Modal show={showModal} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Завершення тесту</Modal.Title>
          </Modal.Header>
          <Modal.Body>Ви закінчили модуль. Ваш рахунок: {score} ⭐</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Закрити
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <div className="test-title" dangerouslySetInnerHTML={{ __html: title }} />
      {currentQuestion.subtitle && <div className="testsubtitle">{currentQuestion.subtitle}</div>}

      {kind === QUESTION_KIND.ONLY_TEXT && (
        <OnlyTextQuestion
          text={currentQuestion.text}
          onNext={nextQuestion}
          canGoNext={!isLastQuestion}
        />
      )}

      {(kind === QUESTION_KIND.TEST || kind === QUESTION_KIND.VIDEO) && (
        <TestQuestion
          question={currentQuestion.question}
          options={currentQuestion.options}
          selectedOption={state.selectedOption}
          optionStatuses={state.optionStatuses}
          onOptionClick={selectOption}
          showCheckButton={state.showCheckButton}
          canCheck={Boolean(state.selectedOption)}
          onCheck={() => checkAnswer("test")}
          feedbackVisible={state.feedbackVisible}
          feedback={state.feedback}
          onCloseFeedback={closeFeedback}
          showNextButton={
            showNextForTest ||
            Boolean(currentQuestion.videoPath && currentQuestion.shouldGoNext && !isLastQuestion)
          }
          onNext={nextQuestion}
          showFinishButton={showFinishForTest}
          onFinish={finishQuiz}
          imgPath={currentQuestion.imgPath}
          videoPath={currentQuestion.videoPath}
          addClass={currentQuestion.addClass}
        />
      )}

      {kind === QUESTION_KIND.DROPDOWN && (
        <DropdownQuestion
          question={currentQuestion.question}
          dropdownQuestionParts={currentQuestion.dropdownQuestionParts}
          options={currentQuestion.options}
          showAnswerOptions={currentQuestion.showAnswerOptions}
          dropdownAmount={currentQuestion.dropdownAmount}
          showCheckButton={state.showCheckButton}
          canCheck={state.allDropdownsSelected}
          onCheck={() => checkAnswer("dropdown")}
          feedbackVisible={state.feedbackVisible}
          feedback={state.feedback}
          onCloseFeedback={closeFeedback}
          showNextButton={showNextForDropdown}
          onNext={nextQuestion}
          showFinishButton={showFinishForDropdown}
          onFinish={finishQuiz}
          onAllDropdownsSelected={setDropdownSelection}
          questionKey={currentQuestion.id || selectedQuestionIndex}
        />
      )}

      {kind === QUESTION_KIND.DND && (
        <GameQuestion
          questionId={currentQuestion.id || selectedQuestionIndex}
          score={score}
          question={currentQuestion.question}
          imgPath={currentQuestion.imgPath}
          videoPath={currentQuestion.videoPath}
          initialWords={currentQuestion.initialWords}
          leftBucketTitle={currentQuestion.leftBucketTitle}
          centerBucketTitle={currentQuestion.centerBucketTitle}
          rightBucketTitle={currentQuestion.rightBucketTitle}
          bucketsAmount={currentQuestion.bucketsAmount}
          onScoreUpdate={handleScoreUpdate}
          onGameOver={setGameOver}
          isGameOver={state.isGameOver}
          showNextButton={showNextForGame}
          onNext={nextQuestion}
          showFinishButton={showFinishForGame}
          onFinish={finishQuiz}
        />
      )}
    </div>
  );
}

export default Module;
